import { createSelector } from 'reselect';
import filterPaintCollections from '../../lib/filters/filterPaintCollections';

const makeSelectFilteredPaintCollections = () =>
  createSelector(
    (state) => state.product,
    (state) => state.color,
    (_, props) => props,
    (productState, colorState, props) => {
      const {
        paintCollections: passedPaintCollections,
        paintCollectionArrangement: passedPaintCollectionArrangement,
        colorWheel: passedColorWheel,
        sorts: passedSorts,
        filterTags: passedTags,
      } = props;

      const paintCollections =
        passedPaintCollections || productState.paintCollections;
      const sorts = passedSorts || colorState.sorts;
      const filterQuery = colorState.filterQuery;
      const filterTags = passedTags || colorState.filterTags;
      const shopifyProducts = productState.shopifyProducts;
      const colorWheel = passedColorWheel || colorState.colorWheel;
      const paintCollectionArrangement = passedPaintCollectionArrangement || [];

      return filterPaintCollections({
        paintCollections,
        paintCollectionArrangement,
        sorts,
        filterQuery,
        filterTags,
        shopifyProducts,
        colorWheel,
      });
    }
  );

export default makeSelectFilteredPaintCollections;
